import { render, staticRenderFns } from "./CoverUploader.vue?vue&type=template&id=bfdc79ba&scoped=true"
import script from "./CoverUploader.vue?vue&type=script&lang=js"
export * from "./CoverUploader.vue?vue&type=script&lang=js"
import style0 from "./CoverUploader.vue?vue&type=style&index=0&id=bfdc79ba&prod&lang=less&scoped=true"
import style1 from "./CoverUploader.vue?vue&type=style&index=1&id=bfdc79ba&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.29.7__cache-loader@2.0.1_web_fe5e962fec43a62c82d69a5f09eb460e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfdc79ba",
  null
  
)

export default component.exports